import { useAppSelector, useAppDispatch } from '../reduxProvider'
import useFetch from '../../utils/fetch/useFetch'
import { UseLocalizationsResult, Localization } from './types'
import { setLocalizations } from './store'

const useLocalizations = (): UseLocalizationsResult => {
  const dispatch = useAppDispatch()
  const { localizations } = useAppSelector((state) => state.localizations)
  const { get } = useFetch()

  const endpoint = 'languages'

  const fetchLocalizations = async () => {
    const response: Localization[] | undefined = await get({ endpoint })
    if (response) {
      dispatch(setLocalizations(response))
    }
  }

  return {
    fetchLocalizations,
    localizations,
  }
}

export default useLocalizations
